module.exports = __webpack_public_path__ + "img/client-logo-arcplan-group.1d46784b.jpg";